<template>
  <div>
    <div class="link-container__greenlist__overlay" v-if="rental.isBlurred">
      <i class="fa fa-lock"></i>
      <a
        :href="rental.url"
        :title="rental.title"
      >
        {{ $t('messages_nl.access-denied-rental.title') }}
      </a>
    </div>
    <div :class="[
    'list-item link-container',
    { 'list-item__greenlist__hidden': rental.isBlurred }
    ]">
      <a
        :href="rental.url"
        :title="rental.title"
      >
        <div :class="`listing-img-wrapper ${showWatermarkOverlay ? 'rental-watermark-overlay-list-image rental-watermark-disable-image-drag' : ''}`">
          <template v-if="showWatermarkOverlay">
            <i class="fa fa-solid fa-lock rental-watermark-overlay-list-image__icon"></i>
            <p class="rental-watermark-overlay-list-image__paragraph">
              {{ $t('messages_nl.contact.tooltip.premium') }}
            </p>
          </template>
          <img
            :src="rental.image.src"
            :srcset="rental.image.srcset"
            sizes="(max-width: 768px) 100vw, 250px"
            class="disable__select__images"
            :class="{
              'no-image': !rental.image.available,
              'img-fluid mx-auto': rental.image.available,
              'listing-img-hidden': rental.isBlurred
            }"
            :alt="rental.title"
            :title="rental.image.title"
            width="250"
            height="250"
            :loading="index === 0 ? 'eager' : 'lazy'"
            :fetchpriority="index === 0 ? 'high' : 'auto'"
            :referrerpolicy="rental.useImageHotlinking ? 'no-referrer' : false"
            oncontextmenu="return false;"
            draggable="false"
          >
          <template>
            <span v-if="rental.status === houseStatuses.under_option" class="property-type property--orange">
              {{ $t('messages_nl.rental.status.underOption') }}
            </span>
            <span v-else-if="rental.status === houseStatuses.rented_out" class="property-type property--red">
              {{ $t('messages_nl.rental.status.rented') }}
            </span>
            <span v-else-if="rental.isNew" class="property-type property--green">
              {{ $t('messages_nl.rental.status.new') }}
            </span>
          </template>
        </div>
      </a>
      <div class="listing-content">
        <div class="listing-content-top">
          <div class="listing-header">
            <div>
              <a
                :href="rental.url"
                :title="rental.title"
                class="listing-name"
              >
                <h2 class="listing-street">
                  {{ rental.street }}
                </h2>
              </a>
              <p class="listing-location">
                {{ formattedLocation }}
              </p>
            </div>
            <div class="listing-price">
              {{ rental.isBlurred ? $t('messages_nl.search.greenlist.placeholders.price') : formattedPrice }}
            </div>
          </div>
          <div
            class="listing-description"
            v-html="truncatedDescription"
          />
        </div>
        <ul class="listing-footer clean">
          <template v-if="!rental.isBlurred">
            <li>
              <strong><i class="fas fa-ruler-combined mb-1"></i></strong>
              {{ formattedSpace }}
            </li>
            <li class="listing-footer-rooms">
              <strong><i class="fas fa-door-open mb-1"></i></strong>
              <div>
                {{ formattedRooms }}
                <span v-if="rental.rooms !== 0">
                  {{ $t('messages_nl.global._room', {'rooms': rental.rooms}) }}
                </span>
              </div>
            </li>
            <li>
              <strong><i class="fas fa-couch mb-1"></i></strong>
              {{ rental.deliveryLevel }}
            </li>
          </template>
          <template v-else>
            <li>
              <strong><i class="fas fa-ruler-combined mb-1"></i></strong>
              {{ $t('messages_nl.search.greenlist.placeholders.surfaceArea') }}
            </li>
            <li class="listing-footer-rooms">
              <strong><i class="fas fa-door-open mb-1"></i></strong>
              {{ $t('messages_nl.search.greenlist.placeholders.rooms') }}
            </li>
            <li>
              <strong><i class="fas fa-home mb-1"></i></strong>
              {{ $t('messages_nl.search.greenlist.placeholders.deliveryLevel') }}
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import sharedJS from '../../../../../common/vue/components-js/list-item-content.js';

export default {
  extends: sharedJS,
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
  }
}
</script>
